var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,36H33a1,1,0,0,0,0-2H16a1,1,0,0,0,0,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,40H33a1,1,0,0,0,0-2H16a1,1,0,0,0,0,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.44,28a12.76,12.76,0,0,0,1.56.4v1.35a1,1,0,0,0,2,0V28.55c.23,0,.46,0,.68-.05a3.83,3.83,0,0,0,2.91-2.11,2.9,2.9,0,0,0-.26-2.88A4.58,4.58,0,0,0,27,21.77a10.26,10.26,0,0,0-1-.3V17.13a5.93,5.93,0,0,1,2,.92,1,1,0,1,0,1.14-1.64A7.8,7.8,0,0,0,26,15.07V13.78a1,1,0,0,0-2,0v1.31a4.22,4.22,0,0,0-3.45,3.24A3.79,3.79,0,0,0,21,21a4.73,4.73,0,0,0,2.84,2L24,23v3.37a7.4,7.4,0,0,1-.92-.26,2.75,2.75,0,0,1-1.4-.95,1,1,0,0,0-1.4-.22,1,1,0,0,0-.22,1.4A4.76,4.76,0,0,0,22.44,28Zm3.86-4.38a2.76,2.76,0,0,1,1.36,1,1,1,0,0,1,.11,1,1.85,1.85,0,0,1-1.39.95c-.12,0-.25,0-.38,0v-3ZM22.71,20a1.71,1.71,0,0,1-.19-1.23A2.09,2.09,0,0,1,24,17.15v3.76A2.52,2.52,0,0,1,22.71,20Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49,0H1A1,1,0,0,0,0,1V14a1,1,0,0,0,1,1h9V49a1,1,0,0,0,.62.92,1,1,0,0,0,1.09-.21l3.22-3.23,2.63,3.16a1,1,0,0,0,1.54,0l2.57-3.08,2.56,3.08a1,1,0,0,0,1.54,0l2.56-3.08,2.57,3.08a1,1,0,0,0,1.53,0l2.64-3.16,3.22,3.23A1,1,0,0,0,39,50a.84.84,0,0,0,.38-.08A1,1,0,0,0,40,49V15h9a1,1,0,0,0,1-1V1A1,1,0,0,0,49,0ZM38,46.59l-2.29-2.3A1,1,0,0,0,35,44a1,1,0,0,0-.72.36l-2.56,3.08L29.1,44.36a1,1,0,0,0-.77-.36,1,1,0,0,0-.77.36L25,47.44l-2.57-3.08a1,1,0,0,0-1.53,0l-2.57,3.08-2.56-3.08A1,1,0,0,0,15,44a1,1,0,0,0-.75.29L12,46.59V14h0V6.49H38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.07ec5fe1.svg";
export { ForwardRef as ReactComponent };